import React from 'react';
import { Card } from 'semantic-ui-react';
import './index.scss';

const CardDataItem = ({ children }) => {
  return (
    <div className='CardDataItem'>
      {children}
    </div>
  )
}

const CardData = ({ children, isSmallWidth = false  }) => {
  return (
    <Card className={`CardData ${isSmallWidth?"CardData--small-width":""}`}>
      {children}
    </Card>
  )
}

export { CardData, CardDataItem };
